export const DASHBOARD_FILES_COUNT = "DASHBOARD_FILES_COUNT"
export const DASHBOARD_FILES_COUNT_SUCCESS = "DASHBOARD_FILES_COUNT_SUCCESS"
export const DASHBOARD_FILES_COUNT_ERROR = "DASHBOARD_FILES_COUNT_ERROR"
